export const isArrayEmpty = (arr?: any[]): boolean => !arr || !arr.length;
